import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "dark" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-center"
      visibleToasts={1}
      className="toaster group"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "group toast w-full flex items-center gap-3 rounded-xl px-4 py-3.5 text-sm font-light tracking-wide shadow-xl border backdrop-blur-md " +
            "bg-[rgba(10,10,10,0.75)] border-[rgba(212,175,55,0.12)] text-white " +
            "dark:bg-[rgba(10,10,10,0.75)] dark:border-[rgba(212,175,55,0.12)] dark:text-white " +
            "[html:not(.dark)_&]:bg-[rgba(255,255,255,0.85)] [html:not(.dark)_&]:border-[rgba(212,175,55,0.15)] [html:not(.dark)_&]:text-[hsl(var(--charcoal))]",
          icon: "text-[hsl(var(--gold))] opacity-60 text-base shrink-0",
          actionButton:
            "!ml-auto shrink-0 !bg-transparent !text-[hsl(var(--gold))] !border-0 !px-2 !py-1 !text-lg !font-normal whitespace-nowrap",
          description: "!text-white/60 !text-xs !font-light min-w-0",
          content: "min-w-0 flex-1",
        },
      }}
      style={{
        paddingBottom: "env(safe-area-inset-bottom, 16px)",
      }}
      {...props}
    />
  );
};

export { Toaster };
